"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth, isFirebaseInitialized } from "@/lib/firebase";
import { TextShimmer } from "@/components/ui/primitives/text-shimmer";

export default function Home() {
  const router = useRouter();
  const firebaseReady = isFirebaseInitialized();
  // useAuthState requires non-null Auth, but we check isFirebaseInitialized() before using it
  const [user, loading] = useAuthState(auth!);

  useEffect(() => {
    // Check if Firebase is initialized
    if (!firebaseReady) {
      // If Firebase is not initialized, redirect to login
      router.replace("/login");
    }
  }, [router, firebaseReady]);

  useEffect(() => {
    if (firebaseReady && !loading) {
      if (user) {
        router.replace("/space/projects");
      } else {
        router.replace("/login");
      }
    }
  }, [user, loading, router, firebaseReady]);

  if (!firebaseReady || loading) {
    return (
      <div className="flex h-screen w-full items-center justify-center">
        <TextShimmer duration={1} className="text-center text-lg">
          Loading
        </TextShimmer>
      </div>
    );
  }

  return null; // Will redirect
}
